// extracted by mini-css-extract-plugin
export default {"gain":"gain--2WjtF","volumeUp":"volumeUp--1VdXO","gainRange":"gainRange--jBN0j"};